import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import AffiliateDashboard from './components/AffiliateDashboard';
import AdminPanel from './components/AdminPanel';
import ResetPasswordPage from './components/ResetPasswordPage';
import AcceptTerms from './components/AcceptTerms';
import './App.css';

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/affiliate" element={<AffiliateDashboard />} />
                    <Route path="/admin" element={<AdminPanel />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/accept-terms" element={<AcceptTerms />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
